<template>
	<div class="content">
		<div v-loading="loading">
			<div class="seach" >
				<div style="margin-left: 20px;">
					您搜索的关键字“{{keyword}}”搜索结果如下：
				</div>
				<div style="margin-right: 20px;">
					<el-input style="width: 200px;" v-model="keyword" placeholder="请输入关键词">
					</el-input><el-button type="primary" @click="seach()">搜索</el-button>
				</div>
				
			</div>
			<ul>
				<li v-for="item in qzssList" @click="tonews(5522,item.seqno)">
					<span class="text">{{ item.title |ellipsis(50) }}</span>
					<span class="time">[{{ item.releasetime|formatTime('YYYY-MM-DD')}}]</span>
				</li>
			</ul>
			<el-empty v-show="empty" description="没有搜索到数据"></el-empty>
			<el-pagination
			  background
			  layout="->,total,prev, pager, next"
			  @current-change="handleCurrentChange($event)"
			  :total="qzsstotal">
			</el-pagination>
		</div>	
	</div>
</template>

<script>
	import axios from "axios";
	import qs from 'qs';
	export default {
		data() {
			return{
				qzssList:[],
				qzsstotal:0,
				keyword:'',
				loading:true,
				empty:false,
			}
		},
		filters: {//限制文本显示字数,超出部分用...代替
		    ellipsis (value,index) {
		      if (!value) return ''
		      if (value.length > index) {
		        return value.slice(0,index) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
		      }
		      return value
		    },
			formatTime(value, format = 'YYYY-MM-DD') {
			    if (!value) return '';
			      const date = new Date(value);
			      const options = {
			        'Y+': date.getFullYear().toString(),        // 年
			        'M+': (date.getMonth() + 1).toString(),      // 月
			        'D+': date.getDate().toString(),             // 日
			        'H+': date.getHours().toString(),            // 时
			        'm+': date.getMinutes().toString(),          // 分
			        'S+': date.getSeconds().toString()           // 秒
			        // 可以继续添加其他格式化选项
			      };
			      for (let k in options) {
			        const reg = new RegExp(`(${k})`);
			        if (reg.test(format)) {
			          format = format.replace(reg, options[k].length === 1 ? `0${options[k]}` : `${options[k]}`);
			        }
			      }
			      return format;
			  },
		},
		watch:{
			'$route.query.activeIndex': function(newValue, oldValue) {
			      this.activeIndex=newValue
			    }
		},
		created(){
			if(this.$route.query.keyword === undefined || this.$route.query.buzType === null){
				alert("参数无效；即将返回首页")
				this.$router.push({path:'/'}) 
			}else{
				this.keyword=this.$route.query.keyword
				this.getList(this.$route.query.keyword,'0')
			}
			
		},
		methods: {
			handleSelect(index){
				if(this.$route.query.activeIndex!==index){
					this.$router.push({path:'/quick?activeIndex='+index}) 
				}
			},
			// 获取政策咨询
			getList(keyword,pagenum){
				this.loading=true;
				const data = encodeURIComponent(keyword)
				axios.post("/token/admin/huaxin/index",qs.stringify({
					data:{"buzType":"5529","keyword":data,"parentViewItemId":"","pagenum":pagenum,"pagerows": "10"},
					url:"appapi70009.json"
				}))
				.then(response => {
					this.loading=false;
					this.qzssList=response.data.result.news.newsList
					this.qzsstotal=response.data.result.news.total
					if(!response.data.result.news.total){
						this.empty=true
					}
				})
				.catch(function(error) {
					// 请求失败处理
					console.log(error);
				});
			},
			seach(){
				this.pageNum=1;
				this.$router.push({path:'/qzss?keyword='+this.keyword}) 
				this.getList(this.keyword,'0');
			},
			tonews(buztype,titleid){
				this.$router.push({path:'/new_details',query: {buzType:buztype,titleId:titleid}}) 
			},
			handleCurrentChange(pagenum) {
				this.getList(this.keyword,pagenum-1);
			},

		}
	}
</script>

<style scoped>
	.content{
		padding-bottom: 20px;
		background-color: #ffffff;
	}
	.seach{
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.content ul{
		margin: 0 20px;
	}
	
	.content li{
		height: 32px;
		line-height: 32px;
		text-align: left;
		list-style-type: none;
		border-bottom: 1px dashed #999
	}
	.content li .text:hover{
		cursor: pointer;
		color: red;
	}
	.content .time{
		float: right;
		margin-right: 4px;
		font-size: 12px;
		color: #999;
	}
</style>